// extracted by mini-css-extract-plugin
module.exports = {"background":"background___295Ya","shadow":"shadow___2gFcJ","image":"image___eI4vK","inner":"inner___3u-F-"};